var exports = {
  "q": "shine__6IfVh0",
  "E": "base__B9KgMd",
};

module.exports = exports;
